import Logger from '../../utils/Logger';

const getDownloadLink = ({
  source,
  name,
}: {
  source: string;
  name: string;
}) => {
  try {
    const url = new URL(source);
    url.searchParams.append('dl', name);
    return url.toString();
  } catch (err) {
    Logger.error('Invalid attachment source caught', source);
    return null;
  }
};

export default getDownloadLink;
